export type TranslationResource = Record<string, unknown>;

const isRecord = (value: unknown): value is TranslationResource =>
  Object.prototype.toString.call(value) === '[object Object]';

export const mergeTranslationResources = (
  base: TranslationResource,
  override: TranslationResource,
): TranslationResource => {
  return Object.entries(override).reduce<TranslationResource>(
    (merged, [key, overrideValue]) => {
      const baseValue = merged[key];

      merged[key] =
        isRecord(baseValue) && isRecord(overrideValue)
          ? mergeTranslationResources(baseValue, overrideValue)
          : overrideValue;

      return merged;
    },
    { ...base },
  );
};
